import { STATUSPAGE } from '@repo/ui';
import { HandleSummaryReportByInternshipLocation } from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import {
  clearSummaryReportByInternshipLocation,
  loadSummaryReportByInternshipLocation,
} from 'presentation/config/store/reports/summary-report-by-internship-location-slice';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useSummaryReportByInternshipLocation = () => {
  // Hooks
  const { reportService } = useService();

  const dispatch = useDispatch();

  const [loading, setLoading] = useState<STATUSPAGE>(STATUSPAGE.DONE);
  const [selectedSubmitBtn, setSelectedSubmitBtn] = useState<string>();
  const [hasFetchedData, setHasFetchedData] = useState(false);

  // Methods PDF-EXCEL
  const requestHandleSummaryReportByInternshipLocation = useCallback(
    (params: HandleSummaryReportByInternshipLocation.Params) => {
      setLoading(STATUSPAGE.LOADING);
      reportService
        .handleSummaryReportByInternshipLocation(params)
        .then((res: any) => {
          let blob = new Blob([res], {
            type: `application/${params?.type === '0' ? 'pdf' : 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'}`,
          });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, '_blank');
        })
        .catch((err) => {
          notifyError(err.message);
        })
        .finally(() => {
          setLoading(STATUSPAGE.DONE);
        });
    },
    [],
  );

  // Methods JSON
  const requestHandleSummaryReportByInternshipLocationJson = useCallback(
    (params: HandleSummaryReportByInternshipLocation.Params) => {
      setLoading(STATUSPAGE.LOADING);
      reportService
        .handleSummaryReportByInternshipLocation(params)
        .then((res: any) => {
          dispatch(loadSummaryReportByInternshipLocation(res));
        })
        .catch((err) => {
          notifyError(err.message);
          dispatch(clearSummaryReportByInternshipLocation());
        })
        .finally(() => {
          setLoading(STATUSPAGE.DONE);
          setHasFetchedData(true);
        });
    },
    [],
  );

  return {
    // States
    loading,
    hasFetchedData,
    selectedSubmitBtn,
    // Methods
    setLoading,
    setSelectedSubmitBtn,
    requestHandleSummaryReportByInternshipLocation,
    requestHandleSummaryReportByInternshipLocationJson,
  };
};
